import React from 'react';
import SelectField from './../Form/SelectField';

const FormP1T10 = React.memo((props) => {
    return (
        <form action="">
            <hr />
            <SelectField
                required
                label="Quantity"
                value={props.quantity}
                setFunction={props.setQuantity}
                options={[
                    { value: '', label: 'Select option' },
                    { value: '250', label: '250' },
                    { value: '500', label: '500' },
                    { value: '1000', label: '1000' },
                ]}
            />
            <hr />
            <h5 className="description-header">Description</h5>
            <div className="description-section">
                <div><span className="label">Title:</span> UTHealth and UT Physicians Billing Card</div>
                <div className="description-list">
                    <span className="label">Description:</span>
                    <ul>
                        <li>Static Item</li>
                        <li>Size 3.5x2</li>
                        <li>One sided</li>
                        <li>Color one side</li>
                        <li>#80 Accent Smooth Cover</li>
                    </ul>
                </div>
            </div>
        </form>
    );
});

FormP1T10.propTypes = {

}

export default FormP1T10;
